/**
 * Created by admin on 2018/8/3.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { Modal, Switch } from 'antd';
import { DEVICE_STATE, SEMICOLON } from '../../utils/constants';
import './RoomDeviceModal.less';
import { Btn } from '../Widgets';
import { FormattedMessage, injectIntl } from 'react-intl';

class RoomDeviceModal extends PureComponent {
  static defaultProps = {
    visible: false,
    currentRoomInfo: {}
  };

  constructor() {
    super();
    this.state = {
      editDevList: []
    };
  }

  componentWillReceiveProps(nextProps) {
    const { visible: preVisible, intl } = this.props;
    const { visible, dispatch, currentRoomInfo } = nextProps;
    if (!preVisible && visible && currentRoomInfo.id) {
      dispatch({
        type: 'roomDevice/update',
        payload: { roomId: currentRoomInfo.id, roomName: currentRoomInfo.name }
      });
      const promise = new Promise((resolve, reject) => {
        dispatch({ type: 'roomDevice/getRoomDevices', resolve, reject });
      });
      promise.then(
        () => {
          const { deviceList = [] } = this.props.roomDevice;
          this.setState({ editDevList: deviceList });
        },
        msg => {
          Modal.error({ content: msg });
        }
      );
    }
  }

  render() {
    const { visible, intl, currentRoomInfo = {} } = this.props;
    const { name = '' } = currentRoomInfo;
    const { editDevList } = this.state;
    return (
      <Modal
        destroyOnClose={true}
        visible={visible}
        onCancel={this.close}
        title={intl.formatMessage({ id: 'room_device_repair_title' })}
        wrapClassName="room-device-wrapper modal-close-header"
        width={600}
        footer={
          <div className="edit-footer">
            <Btn onClick={this.close}>
              {intl.formatMessage({ id: 'modal_manage_btn_cancel' })}
            </Btn>
            <Btn primary onClick={this.save}>
              {intl.formatMessage({ id: 'modal_manage_btn_ok' })}
            </Btn>
          </div>
        }
        closable
      >
        <div className="room-device">
          <div className="device-item">
            <span>{intl.formatMessage({ id: 'room_manage_list_name' })}：</span>
            <span>{name}</span>
          </div>
          {editDevList.map(roomDevice => {
            return (
              <div key={roomDevice.id} className="device-item">
                <span>{`${roomDevice.device.name}：`}</span>
                <span>
                  <Switch
                    checkedChildren={intl.formatMessage({
                      id: 'room_device_fault'
                    })}
                    unCheckedChildren={intl.formatMessage({
                      id: 'room_device_normal'
                    })}
                    checked={roomDevice.state === DEVICE_STATE.FAULT}
                    onChange={this.onCheck.bind(this, roomDevice)}
                  />
                </span>
              </div>
            );
          })}
        </div>
      </Modal>
    );
  }

  onCheck = (roomDevice, checked) => {
    roomDevice.state = checked ? DEVICE_STATE.FAULT : DEVICE_STATE.NORMAL;
    const { editDevList } = this.state;
    this.setState({ editDevList: [].concat(editDevList) });
  };

  close = () => {
    const { onClose } = this.props;
    this.setState({ editDevList: [] });
    onClose && onClose();
  };
  save = () => {
    const { dispatch } = this.props;
    const { editDevList = [] } = this.state;
    let brokenDevIds = [];
    for (let roomDev of editDevList) {
      if (roomDev.state === DEVICE_STATE.FAULT && roomDev.device) {
        brokenDevIds.push(roomDev.device.id);
      }
    }
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'roomDevice/updateRoomDeviceState',
        resolve,
        reject,
        brokenDevIds: brokenDevIds.join(SEMICOLON)
      });
    });
    promise.then(
      () => {
        this.close();
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };
}

const mapStateToProps = state => {
  return {
    roomDevice: state.roomDevice
  };
};

export default connect(mapStateToProps)(RoomDeviceModal);



// WEBPACK FOOTER //
// ./src/components/account/RoomDeviceModal.js